module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', _vm._l((_vm.product.donationtypes), function(donationtype) {
    return _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.type == donationtype),
        expression: "type == donationtype"
      }],
      staticClass: "widget-dollar-handles dollar-handles"
    }, _vm._l((_vm.product.dollarhandles[donationtype]), function(index) {
      return _c('li', {
        attrs: {
          "for": 'handle-' + donationtype + '-' + index.amount
        }
      }, [_c('div', {
        staticClass: "inner"
      }, [_c('div', {
        staticClass: "img"
      }, [_c('span', {
        style: ('background-image: url(' + index.img + ')')
      }), _vm._v(" "), _c('div', {
        staticClass: "handle-container"
      }, [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.dollarhandle),
          expression: "dollarhandle"
        }],
        attrs: {
          "disabled": (_vm.formWizardCurrentStep != 0),
          "type": "radio",
          "name": 'handle-widget-' + donationtype,
          "id": 'handle-widget-' + donationtype + '-' + index.amount
        },
        domProps: {
          "value": index.amount,
          "checked": _vm._q(_vm.dollarhandle, index.amount)
        },
        on: {
          "change": function($event) {
            _vm.dollarhandle = index.amount
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "amount",
        class: {
          'has-cents': !(index.amount.indexOf('.00') >= 0)
        }
      }, [_c('span', [_vm._v("$" + _vm._s((index.amount.indexOf('.00') >= 0) ? index.amount.slice(0, -3) : index.amount))])]), _vm._v(" "), _c('span', {
        staticClass: "handle"
      }), _vm._v(" "), _c('span', {
        staticClass: "svg-circle"
      }, [_c('svg', {
        staticStyle: {
          "width": "100%",
          "height": "100%"
        }
      }, [_c('circle', {
        attrs: {
          "cx": "50%",
          "cy": "50%",
          "r": "40%",
          "stroke-width": "3"
        }
      })])])])])]), _vm._v(" "), _c('div', {
        staticClass: "desc"
      }, [_c('div', {
        staticClass: "desc-inner"
      }, [_c('h5', [_vm._v(_vm._s(index.text))])])])])])
    }))
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-970ee786","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=bhy68egj1x!./~/string-replace-webpack-plugin/loader.js?id=wgppdwdx8dq!./src/components/product/DollarHandleWidget.vue
// module id = 646
// module chunks = 0